import { runTypewriter } from '../streaming/runTypewriter.js'

/** Typing cadence — 3× faster vs prior 22ms/char baseline (~135 chars/sec). */
const SYNTHETIC_DEMO_CHAR_INTERVAL_MS = 7

/** @param {string} text */
function syntheticDemoDurationMs(text) {
  return Math.max(300, text.length * SYNTHETIC_DEMO_CHAR_INTERVAL_MS)
}

/** @param {{ session: object, signal: AbortSignal, text: string, onUpdate: (partial: string) => void, onDone: () => void }} opts */
export function runSyntheticDataDemoTypewriter({ session, signal, text, onUpdate, onDone }) {
  runTypewriter({
    session,
    signal,
    text,
    onUpdate,
    onDone,
    mode: 'char',
    granularity: 'character',
    minStepIntervalMs: SYNTHETIC_DEMO_CHAR_INTERVAL_MS,
    durationMs: syntheticDemoDurationMs(text),
  })
}

export const SYNTHETIC_DEMO_TYPEWRITER_OPTIONS = {
  mode: 'char',
  granularity: 'character',
  minStepIntervalMs: SYNTHETIC_DEMO_CHAR_INTERVAL_MS,
}

/** @param {string} text */
export function syntheticDemoTypewriterDurationMs(text) {
  return syntheticDemoDurationMs(text)
}
